import { UIBModal } from '@b2b/types/core';
import angular from 'angular';
import { PublishingStatusType } from '../../../constants/publishing-status.constants';

export interface PublishingInProgressTemplate {
  name: string;
  publishingStatus?: PublishingStatusType;
  lastPublishedBy?: string;
  lastPublished?: string;
}

export interface PublishingInProgressModalResult {
  action: 'startNew' | 'letFinish';
}

export class TemplatesModalsPublishingInProgressController {
  static $inject = ['$uibModalInstance', 'template'];

  title = 'Publishing in Progress';

  constructor(
    private $uibModalInstance: UIBModal<PublishingInProgressModalResult>,
    public template: PublishingInProgressTemplate
  ) { }

  /**
   * User chooses to start a new publish (will stop current one)
   */
  startNewPublish(): void {
    this.$uibModalInstance.close({ action: 'startNew' });
  }

  /**
   * User chooses to let the current publish finish
   */
  letCurrentFinish(): void {
    this.$uibModalInstance.close({ action: 'letFinish' });
  }

  /**
   * User cancels the action
   */
  cancel(): void {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export const TemplatesModalsPublishingInProgressControllerModule = angular
  .module('acme.view.application.templates.modals.publishingInProgress.controllers', ['ui.bootstrap'])
  .controller('TemplatesModalsPublishingInProgressController', TemplatesModalsPublishingInProgressController).name;

